import { GetQuotesQuery, LookupModel, PagedListingResponseOfQuoteHeaderModel, QuoteHeaderModel } from "@core/services/api.service";

export class LoadQuotesListAction {
    static readonly type = '[QuotesList] Load Quotes list';
    constructor(public payload: { getQuotesQuery: GetQuotesQuery }) { }
}

export class LoadQuotesListSuccessAction {
    static readonly type = '[QuotesList] Load Quotes list Success';
    constructor(public payload: { quotesList: PagedListingResponseOfQuoteHeaderModel }) { }
}

export class LoadQuotesListFailAction {
    static readonly type = '[QuotesList] Load Quotes list Fail';
}

export class GetQuoteByIdAction {
    static readonly type = '[Quote] Get Quote By ID';
    constructor(public quoteId: number) { }
}

export class GetQuoteByIdSuccessAction {
    static readonly type = '[Quote] Get Quote By ID Success';
    constructor(public payload: QuoteHeaderModel) { }
}

export class GetQuoteByIdFailAction {
    static readonly type = '[Quote] Get Quote By ID Fail';
}

export class UpdateQuoteStatusAction {
    static readonly type = '[Quote] Update Quote Status';
    constructor(public payload: { quoteId: number; orderStatusId: number; orderStatusDescription: string }) { }
}

export class UpdateQuoteStatusSuccessAction {
    static readonly type = '[Quote] Update Quote Status Success';
    constructor(public payload: { quoteId: number; orderStatusId: number; orderStatusDescription: string }) { }
}

export class UpdateQuoteStatusFailAction {
    static readonly type = '[Quote] Update Quote Status Fail';
}

export class AssignVehicleTypeSuccessAction {
    static readonly type = '[Quote] Assign Vehicle Type Success';
    constructor(public payload: {
        quoteId: number;
        area: string;
        vehicleTypeId: number;
        vehicleTypeName: string;
        estimatedKm: number;
        estimatedRatePerKm: number;
        estimatedTotal: number;
        numberOfDrivers: number;
        loadingCountry: string;
        dischargeCountry: string;
        carrier: string;
    }) { }
}

export class LoadQuoteStatusesAction {
    static readonly type = '[QuoteStatuses] Load Quote Statuses';
}

export class LoadQuoteStatusesSuccessAction {
    static readonly type = '[QuoteStatuses] Load Quote Statuses Success';
    constructor(public payload: { quoteStatuses: LookupModel[] }) { }
}

export class LoadQuoteStatusesFailAction {
    static readonly type = '[QuoteStatuses] Load Quote Statuses Fail';
}
